module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"from":"von","to":"bis"}}')
  delete Component.options._Ctor
}
